import ManualChapterTitle from './ManualChapterTitle';

export default ManualChapterTitle;
